export const categories = [
  { slug: 'wanghong-heiliao', name: '网红黑料', icon: 'ri-user-smile-line' },
  { slug: 'mingxing-baoliao', name: '明星爆料', icon: 'ri-star-line' },
  { slug: 'fancha-shipin', name: '反差视频', icon: 'ri-contrast-line' },
  { slug: 'liaotian-jilu', name: '聊天记录', icon: 'ri-chat-1-line' },
  { slug: 'dujia-baoliao', name: '独家爆料', icon: 'ri-fire-line' },
  { slug: 'hot', name: '热门吃瓜', icon: 'ri-flashlight-line' },
];

export interface ArticleItem {
  id: number;
  slug: string;
  title: string;
  excerpt: string;
  tag: string;
  category: string;
  categorySlug: string;
  date: string;
  views: number;
  imageUrl: string;
  author: string;
}

export const allArticles: ArticleItem[] = [
  {
    id: 1,
    slug: 'top-influencer-live-fail',
    title: '顶流网红直播翻车现场：千万粉丝博主人设崩塌全记录',
    excerpt: '近日，某拥有千万粉丝的顶流网红在直播中意外翻车，一系列不当言论和行为引发全网热议。',
    tag: '独家爆料',
    category: '网红黑料',
    categorySlug: 'wanghong-heiliao',
    date: '2026-07-06',
    views: 1280000,
    imageUrl: 'https://readdy.ai/api/search-image?query=Dramatic%20studio%20lighting%20scene%20with%20shadowy%20abstract%20figure%20silhouette%20against%20dark%20emerald%20background%2C%20moody%20atmosphere%2C%20editorial%20magazine%20photography%20style%2C%20mysterious%20and%20intriguing%20composition%2C%20soft%20rim%20lighting%20creating%20tension%2C%20cinematic%20color%20grading%20with%20deep%20greens%20and%20blacks%2C%20artistic%20blur%20effects%2C%20empty%20space%20for%20text%20overlay&width=800&height=1120&seq=article-01&orientation=portrait',
    author: '吃瓜前线记者',
  },
  {
    id: 2,
    slug: 'chat-records-leak',
    title: '某知名博主私密聊天记录外泄，内容劲爆引全网热议',
    excerpt: '一份疑似某知名博主与多人的私密聊天记录在网络上疯传，内容涉及多段隐秘关系的细节。',
    tag: '聊天记录',
    category: '聊天记录',
    categorySlug: 'liaotian-jilu',
    date: '2026-07-05',
    views: 965000,
    imageUrl: 'https://readdy.ai/api/search-image?query=Close-up%20abstract%20composition%20of%20fragmented%20text%20messages%20on%20dark%20surface%2C%20warm%20amber%20and%20sage%20green%20color%20palette%2C%20mysterious%20digital%20communication%20theme%2C%20soft%20focus%20artistic%20photography%2C%20glowing%20screen%20reflections%2C%20intimate%20and%20secretive%20atmosphere%2C%20editorial%20style%20with%20shallow%20depth%20of%20field%2C%20high-end%20magazine%20aesthetic&width=800&height=520&seq=article-02&orientation=landscape',
    author: '深度调查员',
  },
  {
    id: 3,
    slug: 'contrast-blogger-exposed',
    title: '反差萌博主真实身份大曝光，甜美形象背后另有隐情',
    excerpt: '以甜美形象走红的某反差博主被网友扒出真实身份，与其人设形成了巨大反差。',
    tag: '反差视频',
    category: '反差视频',
    categorySlug: 'fancha-shipin',
    date: '2026-07-04',
    views: 845000,
    imageUrl: 'https://readdy.ai/api/search-image?query=Dual-tone%20abstract%20composition%20split%20between%20soft%20pink%20and%20dark%20muted%20teal%2C%20contrasting%20textures%20and%20moods%2C%20artistic%20duality%20concept%2C%20modern%20editorial%20photography%2C%20mysterious%20and%20thought-provoking%20atmosphere%2C%20soft%20gradient%20blending%2C%20sophisticated%20color%20palette%20with%20warm%20and%20cool%20tones%2C%20magazine%20cover%20style%20with%20elegant%20negative%20space&width=800&height=520&seq=article-03&orientation=landscape',
    author: '八卦研究所',
  },
  {
    id: 4,
    slug: 'celebrity-marriage-crisis',
    title: '明星夫妻婚姻危机升级，男方夜会神秘女子被拍',
    excerpt: '娱乐圈又一对模范夫妻面临婚姻危机，男方深夜与神秘女子约会的照片被曝光。',
    tag: '独家爆料',
    category: '明星爆料',
    categorySlug: 'mingxing-baoliao',
    date: '2026-07-04',
    views: 1560000,
    imageUrl: 'https://readdy.ai/api/search-image?query=Moody%20nighttime%20abstract%20scene%20with%20warm%20amber%20street%20light%20reflections%2C%20blurred%20figures%20in%20the%20distance%2C%20cinematic%20noir%20atmosphere%2C%20dark%20emerald%20and%20golden%20tones%2C%20mysterious%20urban%20night%20photography%20style%2C%20soft%20focus%20artistic%20composition%2C%20elegant%20editorial%20aesthetic%20with%20dramatic%20shadows&width=800&height=520&seq=article-04&orientation=landscape',
    author: '吃瓜前线记者',
  },
  {
    id: 5,
    slug: 'influencer-tax-evasion',
    title: '知名带货网红涉嫌偷税漏税，直播间已紧急停播',
    excerpt: '继多位头部主播被查后，又一位知名带货网红因涉嫌税务问题被立案调查。',
    tag: '重磅消息',
    category: '网红黑料',
    categorySlug: 'wanghong-heiliao',
    date: '2026-07-03',
    views: 2340000,
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20composition%20with%20harsh%20fluorescent%20lighting%2C%20empty%20studio%20atmosphere%2C%20abandoned%20broadcast%20equipment%20silhouettes%2C%20stark%20contrast%20between%20light%20and%20dark%2C%20cold%20institutional%20aesthetic%2C%20modern%20editorial%20style%20with%20dramatic%20negative%20space%2C%20muted%20teal%20and%20grey%20tones%20with%20subtle%20warm%20accents&width=800&height=520&seq=article-05&orientation=landscape',
    author: '深度调查员',
  },
  {
    id: 6,
    slug: 'boy-band-member-scandal',
    title: '当红男团成员卷入私生活丑闻，经纪公司紧急发声明',
    excerpt: '某当红男团成员被爆出与多名粉丝保持不正当关系，聊天截屏和合照被大量传播。',
    tag: '聊天记录',
    category: '明星爆料',
    categorySlug: 'mingxing-baoliao',
    date: '2026-07-03',
    views: 1890000,
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20composition%20of%20shattered%20mirror%20fragments%20reflecting%20distorted%20light%2C%20dramatic%20contrast%20between%20bright%20white%20and%20dark%20shadow%20areas%2C%20symbolic%20broken%20image%20concept%2C%20editorial%20artistic%20photography%2C%20moody%20atmosphere%20with%20cool%20metallic%20tones%2C%20sophisticated%20magazine%20style%2C%20conceptual%20representation%20of%20scandal&width=800&height=520&seq=article-06&orientation=landscape',
    author: '八卦研究所',
  },
  {
    id: 7,
    slug: 'beauty-blogger-fake-products',
    title: '美妆博主被扒用假货测评，粉丝怒斥欺骗信任',
    excerpt: '一位拥有300万粉丝的美妆博主被网友发现其测评使用的竟是假冒伪劣产品。',
    tag: '反差视频',
    category: '反差视频',
    categorySlug: 'fancha-shipin',
    date: '2026-07-02',
    views: 1120000,
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20composition%20of%20luxury%20cosmetic%20items%20dissolving%20into%20geometric%20fragments%2C%20contrast%20between%20glossy%20surfaces%20and%20rough%20textures%2C%20muted%20cream%20and%20dark%20emerald%20color%20palette%2C%20editorial%20conceptual%20photography%2C%20sophisticated%20artistic%20style%20with%20mysterious%20undertones%2C%20elegant%20decay%20aesthetic&width=800&height=520&seq=article-07&orientation=landscape',
    author: '吃瓜前线记者',
  },
  {
    id: 8,
    slug: 'game-streamer-cheating',
    title: '游戏主播代打实锤，高段位账号竟是团队在操作',
    excerpt: '某知名游戏主播被爆出直播时画面与操作不符，疑似由团队代打维持高段位人设。',
    tag: '独家爆料',
    category: '网红黑料',
    categorySlug: 'wanghong-heiliao',
    date: '2026-07-02',
    views: 978000,
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20gaming%20scene%20with%20ghostly%20digital%20controller%20silhouette%20dissolving%20into%20pixel%20fragments%2C%20dramatic%20cyan%20and%20dark%20teal%20color%20contrast%2C%20futuristic%20yet%20moody%20atmosphere%2C%20editorial%20technology%20photography%2C%20mysterious%20computational%20aesthetic%2C%20soft%20glowing%20elements%20against%20dark%20background&width=800&height=520&seq=article-08&orientation=landscape',
    author: '深度调查员',
  },
  {
    id: 9,
    slug: 'actress-secret-relationship',
    title: '当红女星地下恋情曝光，对象竟是圈外普通人',
    excerpt: '一向以单身人设示人的某当红女星，被拍到与一名圈外男子深夜牵手同行。',
    tag: '重磅消息',
    category: '明星爆料',
    categorySlug: 'mingxing-baoliao',
    date: '2026-07-01',
    views: 2010000,
    imageUrl: 'https://readdy.ai/api/search-image?query=Romantic%20nighttime%20abstract%20scene%20with%20soft%20bokeh%20light%20circles%2C%20warm%20golden%20and%20deep%20emerald%20color%20palette%2C%20blurred%20couple%20silhouette%20in%20background%2C%20dreamy%20atmospheric%20photography%2C%20elegant%20editorial%20style%2C%20cinematic%20mood%20with%20gentle%20light%20leaks%2C%20sophisticated%20artistic%20composition&width=800&height=520&seq=article-09&orientation=landscape',
    author: '八卦研究所',
  },
];

export const categoriesMap: Record<string, ArticleItem[]> = {};
allArticles.forEach((item) => {
  if (!categoriesMap[item.categorySlug]) {
    categoriesMap[item.categorySlug] = [];
  }
  categoriesMap[item.categorySlug].push(item);
});